import { useQuery } from '@tanstack/react-query';
import { fetchEcommRecentTransac, type EcommOrder } from '../services/ecommRecentTransacService';


export const useEcommRecentTransac = (limit = 60) => {
  return useQuery<EcommOrder[], Error>({
    queryKey: ['ecomm-recentTransactions', limit],
    queryFn: () => fetchEcommRecentTransac(limit),
    staleTime: 1000 * 60 * 5,
  });
};